import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import React from 'react';
import propTypes from 'prop-types';

/**
 * Helper function to convert ebab period data from format stored in DynamoDB (YYYY-QX) to format displayed on site (QX YYYY)
 * @param {string} periodInfo ebab period in format YYYY-QX
 * @returns {string} ebab period in format QX YYYY
 */
function convertPeriodFormat(periodInfo) {
    return periodInfo.split('-').reverse().join(' ');
}

const AppPageHeaderDescription = ({ id, ebabPeriod }) => {
    return (
        <Typography
            id={id}
            component='h2'
            variant='body_show_medium_and_up'
            data-testid={'subheader'}
            style={{ maxWidth: '80%' }}
        >
            This analysis uses Essentia&apos;s peer-reviewed methodology to
            assess decision-making skills across a{' '}
            <Box
                display='inline-block'
                sx={{ fontWeight: '550', whiteSpace: 'pre' }}
            >
                36 month
            </Box>{' '}
            period. All portfolios are analyzed{' '}
            <Box
                display='inline-block'
                sx={{ fontWeight: '550', whiteSpace: 'pre' }}
            >
                relative to their prospectus benchmark
            </Box>
            . The current period runs to the end of{' '}
            <Box
                display='inline-block'
                sx={{ fontWeight: '550', whiteSpace: 'pre' }}
            >
                {ebabPeriod
                    ? convertPeriodFormat(ebabPeriod) + '.'
                    : '                '}
            </Box>
        </Typography>
    );
};

AppPageHeaderDescription.propTypes = {
    id: propTypes.string,
    ebabPeriod: propTypes.string
};

export default AppPageHeaderDescription;
